module.exports = __webpack_public_path__ + "static/media/app-store-badge.1824725b.png";